import React, { useEffect } from "react";
import { useStateValue } from "./StateProvider";
import "./TeamScore.css"

function TeamScore() {
  const [{ hole }] = useStateValue();
  const [{players}]= useStateValue();
  const [{ scores }] = useStateValue();
  const [{ teammatch }, dispatch4] = useStateValue();

  useEffect(() => {
    localStorage.setItem("teammatch",JSON.stringify(teammatch));
  }, [teammatch]);

  useEffect(() => {
    // save teammatch if #scores for hole equals # players
    if (scores.filter((s) => s.hole === hole).length === players.length) {
      //get scores for current hole
      const holeScores = scores.filter((s) => s.hole === hole);
      //join query  players with scores
      var teams = [];
      for (var i = 0; i < holeScores.length; i++) {
        for (var j = 0; j < players.length; j++) {
          if (holeScores[i].id === players[j].id) {
            teams.push({
              id: holeScores[i].id,
              strokes: holeScores[i].strokes,
              team: players[j].team,
            });
          }
        }
      }
      // console.log("Teams", teams);
      // get plus team
      const plus = teams.filter((s) => s.team === "Plus");
      // plus team score
      const plusTotal = plus?.reduce(
        (totalStrokes, score) => totalStrokes + score.strokes,
        0
      );
      // get minus team
      const minus = teams.filter((s) => s.team === "Minus");
      // minus team score
      const minusTotal = minus?.reduce(
        (totalStrokes, score) => totalStrokes + score.strokes,
        0
      );
    
      var plusminus = plusTotal - minusTotal < 0 ? +1 : -1;
      plusminus = plusTotal - minusTotal === 0 ? 0 : plusminus;
  
      dispatch4({
        type: "SAVETEAMSCORE",
        teammatch: {
          hole: hole,
          plusTotal: plusTotal,
          minusTotal: minusTotal,
          result: plusminus,
        },
      });
    }
  }, [scores]);

  const getFrontTeam = () => {
    const frontNine = teammatch.filter((s) => s.hole <=9);
    var frontTotal = frontNine?.reduce(
      (totalMatch, match) => totalMatch + match.result,
      0
    );
    frontTotal = frontTotal > 0 ? "+" + frontTotal :  frontTotal;
    const holesLeft= 9-frontNine.length
    return frontTotal + "/" + holesLeft;
  };

  const getFrontWin = () => {
    const frontNine = teammatch.filter((s) => s.hole <=9);
    var frontTotal = frontNine?.reduce(
      (totalMatch, match) => totalMatch + match.result,
      0
    );
    const holesLeft= 9 - frontNine.length
    const x = Math.abs(frontTotal)-holesLeft

    if(x>0){ 
      const winTeam = frontTotal>0?"plus":"minus"
      return "WON"
    }else{
      if(x===0){
        return "DORMIE"
      }else{
        return null
      }
    }
  
    }  
    
    const getBackWin = () => {
      const backNine = teammatch.filter((s) => s.hole >9);
      var backTotal = backNine?.reduce(
        (totalMatch, match) => totalMatch + match.result,
        0
      );
      const holesLeft= 9 - backNine.length
      const x = Math.abs(backTotal)-holesLeft
  
      if(x>0){ 
        const winTeam = backTotal>0?"plus":"minus"
        return "WON"
      }else{
        if(x===0){
          return "DORMIE"
        }else{
          return null
        }
      }
    }



  const getBackTeam = () => {
    const backNine = teammatch.filter((s) => s.hole >=10);
    var backTotal = backNine?.reduce(
      (totalMatch, match) => totalMatch + match.result,
      0
    );
    backTotal = backTotal > 0 ? "+" + backTotal :  backTotal;
    const holesLeft= 9-backNine.length

    if(Math.abs(backTotal)>holesLeft){}    ///*save winner************************************** */
    return backTotal + "/" + holesLeft;
  };

// console.log("In Teams", (players.filter((p)=>p.inTeam9===true)).length)

  const inTeams=()=>{
  return (players.filter((p)=>p.inTeam9===true)).length > 0 ? true:false
  }

  return (

    <div className="teammatches">
{inTeams()?
<div>          
    <div className="tm__title">
    <span>Team Match</span>
    </div>
  
   {hole <= 9 ?
    <div className="ninehole__match">
      <h5 >Team Total: {getFrontTeam()}</h5>
      <span className="frontback">FRONT</span>
  
      <span className="match__standing">{getFrontWin()}</span>
        {/* {Math.abs(teamTotal)-holesLeftToPlay() > 0?"MATCH WON":Math.abs(teamTotal)-holesLeftToPlay() === 0? "DORMIE":""}</span> */}
    </div>:null}

    {hole>=10?
    <div className="ninehole__match">
      <h5>Team Total: {getBackTeam()}</h5>
      <span className="frontback">BACK</span>
      <span className="match__standing" >{getBackWin()}</span>
        {/* {Math.abs(teamTotal)-holesLeftToPlay() > 0?"MATCH WON":Math.abs(teamTotal)-holesLeftToPlay() === 0? "DORMIE":""}</span> */}
    </div>:null}
    

    </div> : null}
    </div>
  );
}

export default TeamScore;
